/**
 * Parses a numeric unit and ensures it falls within the given range (inclusive).
 *
 * @param value - raw input string
 * @param min - minimum allowed value (inclusive)
 * @param max - maximum allowed value (inclusive)
 * @returns The parsed number or undefined if invalid or out of range.
 */
export const parseUnitInRange = (value: string, min: number, max: number): number | undefined => {
  const num = Number(value);
  if (isNaN(num)) return undefined; //  NaN check
  if (num < min || num > max) return undefined; // Range check
  return num;
};

// Helper that attempts parsing with validation; -1 if out of bounds
export const parse = (value: string, min: number, max: number): number => parseUnitInRange(value, min, max) ?? -1;
